<template>
  <div class="w-100">
    <div>
      <v-list nav density="compact" class="pa-0 w-100" v-for="(cond, index) in localConditions" :key="index">
        <ui-list-item class="ui-card" :title="cond.value !== null
          ? `Als ${cond.field} ${getOperatorLabel(cond.operator)} ${cond.value}`
          : `Als ${cond.field} ${getOperatorLabel(cond.operator)}`
        " @click="internalDialog = true" />
        <div v-if="localConditions.length > 1 && index < localConditions.length - 1" class="text-center">
          <v-chip color="var(--primary)" class="px-5">EN</v-chip>
        </div>
      </v-list>
    </div>
    <div class="text-right pt-1">
      <v-btn color="var(--primary)" @click="internalDialog = true" variant="text" class="btn btn-sm">
        <ui-icon name="plus" />
        {{ btnText }}
      </v-btn>
    </div>
    <v-dialog v-model="internalDialog" class="dialog-right-drawer" transition="slide-x-reverse-transition"
      max-width="900px" scrollable persistent>
      <template #default>
        <v-slide-x-reverse-transition>
          <v-card color="#eff3f7" class="canvas-background">
            <v-toolbar color="primary" dark>
              <v-toolbar-title class="ui-h4 text-white">Filter data</v-toolbar-title>
              <v-spacer />
              <v-btn color="var(--white)" class="btn btn-sm" @click="internalDialog = false">
                Opslaan
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <div class="container-sm">
                <div class="condition-main py-10">
                  <div class="text-center">
                    <v-chip color="#515353" variant="flat" class="px-10 mb-4" style="z-index: 2">
                      Als de onderstaande
                    </v-chip>
                  </div>
                  <div class="condition-cards" v-for="(cond, index) in localConditions" :key="index">
                    <div class="card-group">
                      <div class="ui-card">
                        <collapse-section :title="cond.value !== null
          ? `Als ${cond.field} ${getOperatorLabel(cond.operator)} ${cond.value
          }`
          : `Als ${cond.field} ${getOperatorLabel(cond.operator)}`
        " :open="true">
                          <k-field-group name="" labelcolclass="py-0" labelsize="12" class="py-0">
                            <div class="w-100 d-flex justify-content-between flex-wrap flex">
                              <div class="w-33 pr-1">
                                <div class="ui-input">
                                  <label class="ui-label">Veld</label>
                                  <v-select v-model="cond.field" :items="fields" item-title="label"
                                    item-value="column_name" placeholder="Selecteer een veld" variant="solo"
                                    density="compact" menu-icon="fal fa-chevron-down"
                                    :menu-props="{ class: 'kyano-menu' }" />
                                </div>
                              </div>

                              <div class="w-33 px-1">
                                <div class="ui-input">
                                  <label class="ui-label">Operator</label>
                                  <v-select v-model="cond.operator" :items="operators" item-title="label"
                                    item-value="value" placeholder="Operator" variant="solo" density="compact"
                                    menu-icon="fal fa-chevron-down" :menu-props="{ class: 'kyano-menu' }" />
                                </div>
                              </div>

                              <div class="w-33 pl-1" v-if="![
          'empty',
          'is_signed_in_user',
          'is_not_signed_in_user',
        ].includes(cond.operator)
        ">
                                <div class="ui-input">
                                  <label class="ui-label">Waarde</label>
                                  <v-text-field v-model="cond.value" :type="cond.field === 'prijs' ? 'number' : 'text'"
                                    placeholder="waarde" variant="solo" density="compact" />
                                </div>
                              </div>
                            </div>
                          </k-field-group>
                        </collapse-section>
                      </div>
                      <v-btn class="c-delete-btn ui-btn-icon ui-btn" @click="removeCondition(index)"
                        color="var(--danger)" size="small" variant="text" icon>
                        <ui-icon name="trash-2" />
                      </v-btn>
                    </div>
                    <div v-if="localConditions.length > 1 && index < localConditions.length - 1
        " class="c-and-or text-center">
                      <v-chip color="#515353" variant="flat" class="px-5 mb-4">EN</v-chip>
                    </div>
                  </div>
                  <div class="text-center pb-15">
                    <v-btn color="var(--primary)" class="add-item-btn text-white" variant="flat" icon
                      @click="addCondition">
                      <ui-icon name="plus" />
                    </v-btn>
                  </div>
                  <div class="text-center">
                    <v-chip color="#515353" variant="flat" class="px-10 mb-4">Toon dan</v-chip>
                  </div>
                  <div class="condition-cards text-center">
                    <div class="ui-card ui-card-lg">
                      <h4 class="ui-h4">De resultaten</h4>
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-slide-x-reverse-transition>
      </template>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "BottomSheetConditions",
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    btnText: {
      type: String,
      default: "Toevoegen",
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalDialog: this.show,
      localConditions: JSON.parse(JSON.stringify(this.modelValue)),
      operators: [
        { value: "eq", label: "is" },
        { value: "neq", label: "is niet" },
        { value: "in", label: "is in" },
        { value: "nin", label: "is niet in" },
        { value: "empty", label: "is leeg" },
        { value: "contains", label: "bevat" },
        { value: "not_contains", label: "bevat niet" },
        { value: "included_in", label: "is opgenomen in" },
        { value: "not_included_in", label: "is niet opgenomen in" },
        { value: "is_signed_in_user", label: "is ingelogde gebruiker" },
        { value: "is_not_signed_in_user", label: "is niet ingelogde gebruiker" },
      ],
    };
  },
  watch: {
    show(val) {
      this.internalDialog = val;
    },
    internalDialog(val) {
      this.$emit("update:show", val);
    },
    localConditions: {
      deep: true,
      handler(newVal) {
        this.$emit("update:modelValue", newVal);
      },
    },
    modelValue: {
      deep: true,
      handler(newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.localConditions)) {
          this.localConditions = JSON.parse(JSON.stringify(newVal));
        }
      },
    },
  },
  methods: {
    getOperatorLabel(value) {
      const op = this.operators.find((o) => o.value === value);
      return op ? op.label : value;
    },
    addCondition() {
      this.localConditions.push({
        field: this.fields[0]?.value || "",
        operator: "eq",
        value: "",
      });
    },
    removeCondition(index) {
      this.localConditions.splice(index, 1);
    },
  },
};
</script>

<style>
.condition-cards {
  max-width: 550px;
  position: relative;
  margin: auto;

  .card-group {
    gap: 25px !important;
    display: flex;
  }

  .ui-card {
    width: 100%;
    margin-bottom: 25px;
  }

  .c-delete-btn {
    position: absolute;
    right: -50px;
  }

  .c-and-or {
    position: relative;

    &:before {
      content: "";
      height: 100px;
      width: 3px;
      position: absolute;
      left: 50%;
      top: -50%;
      transform: translateX(-50%);
      background: #515353;
    }
  }

  .v-divider {
    display: none;
  }
}

.add-item-btn {
  position: relative;
  overflow: visible;
  z-index: 1;

  &:before {
    content: "";
    height: 50px;
    width: 3px;
    position: absolute;
    left: 50%;
    top: -25px;
    z-index: -1;
    transform: translateX(-50%);
    background: #24a1c7;
  }
}
</style>
